<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <v-card>
      <v-card-text>
        <h3 class="mb-5">Mano dokumentai</h3>
        <savitarna-dokumentai-search
          class="mt-1 mb-1"
          :loading="loading"
          @search="searchPerduoti"
        />
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filterItemList"
          :search="search"
          :hide-default-footer="hideFooter"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageText: 'Rodyti po:',
            itemsPerPageAllText: 'visi',
            itemsPerPageOptions: itemsPerPageOptions,
          }"
          :sort-by.sync="pagination.sort"
          :sort-desc.sync="pagination.sortDesc"
          :server-items-length="pagination.total"
          :items-per-page="pagination.pageSize"
          :page.sync="pagination.page"
          @update:options="updatePagination"
        >
          <template #[`item.obj_busena`]="{ item }">
            <el-hipoteka-busena :busena="item.obj_busena" />
          </template>
          <template #[`item.actions`]="{ item }">
            <el-savitarna-action
              :item="item"
              :loading="item.loading"
              @savitarnaAction="savitarnaAction"
            />
          </template>
          <template slot="loading">
            Kraunasi...
          </template>
          <template slot="no-results">
            Duomenų nėra
          </template>
          <template slot="no-data">
            Duomenų nėra
          </template>
          <template #[`footer.page-text`]="props">
            Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
            {{ props.itemsLength }}
          </template>
        </v-data-table>

        <modal-delete
          title="Šalinti dokumentą?"
          :text="
            `Ar norite pašalinti rengiamą dokumentą <strong>${modalDeleteVardas}</strong>?`
          "
          v-model="showDelete"
          :item="modalDeleteItem"
          @confirmDelete="confirmDelete"
          @cancelDelete="cancelData"
        />
        <modal-confirm
          :title="modalConfirmTitle"
          :text="modalConfirmText"
          v-model="showConfirm"
          :item="modalConfirmItem"
          @confirmConfirm="confirmConfirm"
          @cancelConfirm="cancelData"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import HipotekaMap from '../hipoteka/hipotekaMap'
import SavitarnaDokumentaiSearch from './SavitarnaDokumentaiSearch'
import ModalDelete from '../modals/ModalDelete'
import ModalConfirm from '../modals/ModalConfirm'
import savitarnaVeiksmas from '../../mixins/savitarnaVeiksmas'

export default {
  name: 'SavitarnaDokumentai',
  components: {
    SavitarnaDokumentaiSearch,
    ModalDelete,
    ModalConfirm,
  },
  mixins: [savitarnaVeiksmas],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmItem: null,
      showConfirm: false,
      pranesimai: [],
      veiksmasLoading: null,
      headers: [
        {
          text: 'Dokumento numeris',
          align: 'start',
          sortable: false,
          value: 'obj_dokumento_numeris',
        },
        {
          text: 'Objekto rūšis',
          align: 'start',
          sortable: false,
          value: 'hipotekaTipas',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          sortable: false,
          value: 'identifikavimo_kodas_registre',
        },
        {
          text: 'Šalis (pirma)',
          align: 'start',
          sortable: false,
          value: 'skolininkai',
        },
        {
          text: 'Šalis (antra)',
          align: 'start',
          sortable: false,
          value: 'kreditoriai',
        },
        {
          text: 'Objekto įregistravimo registre data',
          align: 'start',
          sortable: false,
          value: 'obj_iregistravimo_data',
        },
        {
          text: 'Objekto išregistravimo data',
          align: 'start',
          sortable: false,
          value: 'obj_isregistravimo_data',
        },
        {
          text: 'Būsena',
          align: 'center',
          sortable: false,
          value: 'obj_busena',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          sortable: false,
          value: 'obj_busenos_data',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
    }
  },
  computed: {
    filterItemList() {
      return this.pranesimai.map(pranesimas => {
        pranesimas.hipotekaTipas = HipotekaMap['hipotekaTipas'][
          pranesimas.pranesimo_rusis
        ]
          ? HipotekaMap['hipotekaTipas'][pranesimas.pranesimo_rusis].title
          : pranesimas.pranesimo_rusis
        pranesimas.skolininkai = pranesimas.skol_ir_gav.join(', ')
        pranesimas.kreditoriai = pranesimas.kred_ir_dav.join(', ')

        pranesimas.veiksmasList = pranesimas.veiksmai.map(veiksmas => {
          let veiksmasNew = {
            kodas: veiksmas,
            title: veiksmas,
            role: [],
          }

          let key = Object.keys(HipotekaMap['savitarnaVeiksmas']).find(
            e => veiksmas === e
          )
          if (key) {
            veiksmasNew = {
              kodas: veiksmas,
              ...HipotekaMap['savitarnaVeiksmas'][key],
            }
          }

          return veiksmasNew
        })

        return pranesimas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    // this.getData()
    this.pageloading = true
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`pranesimas/mano-dokumentai`, data)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchPerduoti(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
</style>
